const pegasusMustangUrl = process.env.VUE_APP_PEGASUS_MUSTANG;
const pegasusPangareUrl = process.env.VUE_APP_PEGASUS_PANGARE;
const postgradBoardsGroupsUrl = process.env.VUE_APP_POSTGRAD_BOARDS_GROUPS_URL;
const postgradStudyPlanningUrl =
  process.env.VUE_APP_POSTGRAD_STUDY_PLANNING_URL;

export const ENDPOINTS = {
  pegasusMustangUrl,
  pegasusPangareUrl,
  postgradBoardsGroupsUrl,
  postgradStudyPlanningUrl,
};
